import * as React from "react"

export default function CompetitionIcon(props) {
  return (
    <svg
      width={33}
      height={32}
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M24.5 31H8.5V29H24.5V31ZM25.5 5H31.5V8C31.5 11.7005 28.6284 14.7278 24.9922 14.9805C23.8679 18.1839 20.9848 20.557 17.5 20.9424V25H21.5V27H11.5V25H15.5V20.9424C12.0151 20.557 9.131 18.1841 8.00684 14.9805C4.37104 14.7273 1.5 11.7001 1.5 8V5H7.5V1H25.5V5ZM9.5 12C9.5 15.866 12.634 19 16.5 19C20.366 19 23.5 15.866 23.5 12V3H9.5V12ZM3.5 8C3.5 10.435 5.241 12.4617 7.5459 12.9072C7.51603 12.6088 7.5 12.3062 7.5 12V7H3.5V8ZM25.5 12C25.5 12.3063 25.483 12.6088 25.4531 12.9072C27.7585 12.4621 29.5 10.4353 29.5 8V7H25.5V12Z"
        fill={props.fill}
      />
    </svg>
  )
}